/**
 * Once-only creation header helper.
 *
 * A create route that takes an Idempotency-Key answers a repeat under the same
 * key with the record the first request made, so a request retried after its
 * answer was lost cannot create a second record. One builder keeps the header
 * name identical at every call site, as ifMatch.ts does for If-Match.
 */

/** Request-config fragment carrying the key that makes one create happen once. */
export const idempotencyHeaders = (
  key: string
): { headers: { 'Idempotency-Key': string } } => ({
  headers: { 'Idempotency-Key': key },
})
